module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_arrow.2decb30177b4770e593eb483dc36b863.png";